import script from "./InventoryView.vue?vue&type=script&setup=true&lang=js"
export * from "./InventoryView.vue?vue&type=script&setup=true&lang=js"

import "./InventoryView.vue?vue&type=style&index=0&id=cdec1116&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cdec1116"]])

export default __exports__